import { LucideIcon } from "lucide-react";

interface TProps {
    heading?: string,
    subHeading?: string,
    industries?: {
        title: string,
        description: string,
        icon: LucideIcon,
    }[]
}

const TypesSection = ({
    heading = "Who Greet Is For",
    subHeading = "From entertainment venues to educational institutions, Greet powers exceptional guest experiences",
    industries,
}: TProps) => {
    return (
        <section className='max-w-full bg-[#0B0D17] px-4 py-16 sm:px-6 xl:py-[100px] overflow-hidden'>
            <div className='flex flex-col text-center'>
                <h2 className='text-3xl font-extrabold text-white sm:text-4xl lg:text-5xl leading-11 sm:leading-12 md:leading-16'>
                    {heading}
                </h2>
                <p className='mt-2 text-base font-semibold text-gray-500'>
                    {subHeading}
                </p>
            </div>

            <div className='mx-auto mt-12 grid max-w-7xl grid-cols-1 gap-6 px-4 text-center sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 md:px-8 lg:gap-8'>
                {industries?.map((item, index) => {
                    const Icon = item.icon;
                    return (
                        <div
                            key={index}
                            className="bg-[#13151C] rounded-2xl p-8 flex flex-col items-center text-center hover:bg-[#1A1D26] border border-transparent hover:border-white/5 cursor-pointer transition-all duration-300 hover:-translate-y-2 hover:shadow-2xl"
                        >
                            <div className="w-16 h-16 rounded-2xl bg-[#FF4444]/10 flex items-center justify-center mb-6">
                                <Icon className="w-8 h-8 text-primary" strokeWidth={1.5} />
                            </div>
                            <h3 className="text-white text-lg font-bold mb-3">{item.title}</h3>
                            <p className="text-gray-400 text-sm leading-relaxed">
                                {item.description}
                            </p>
                        </div>
                    );
                })}
            </div>
        </section>
    );
}

export default TypesSection;